export default __webpack_public_path__ + "static/bertholdbrodersen-consulting-3031678_1920-77ae76359b5c8b92f8022ad73368bc9d.jpg";